<template>
  <div class="osh-balance-information">
    <information button-title="לחישוב התזרים שלי" :button-action="next"
                 animation-name="osh-balance.json">
      <template v-slot:information-title>
        <div>עם התזרים החודשי קל יותר</div>
        <div>להתחיל לשים כסף בצד</div>
      </template>
      <template v-slot:information-description>
        <div>
          <div v-if="balance">
            <div>אז כרגע מצב העו״ש שלך הוא ₪{{balance}}</div>
            <br/>
          </div>
          <div>מיד נבנה לך תזרים ראשון ונציג לך בדיוק בדיוק כמה אפשר עוד להוציא עד סוף החודש</div>
          <br/>
          <div>
            <span>החודש הסתיים בתזרים חיובי?</span>
            <span class="bold">שמת כסף בצד והגדלת את היתרה בבנק!</span>
          </div>
        </div>
      </template>
    </information>
  </div>
</template>
<script>

import { mapActions, mapState } from 'vuex';
import Information from './components/Information';
import Segment from '../../../../../Segment';

export default {
  components: {
    Information,
  },
  name: 'OshBalanceInformationOld',
  async created() {
    this.init();
    Segment.trackUserGot('OBbalancestateenteredOld');
    Segment.trackUserGot('OBbalancestateenteredOld_Marketing');
  },
  computed: {
    ...mapState('balance', ['balances']),
    balance() {
      if (this.balances.length === 1) {
        return this.balances[0].balance.toLocaleString(undefined, { maximumFractionDigits: 0, minimumFractionDigits: 0 });
      }
      return null;
    },
  },
  methods: {
    ...mapActions('onboardingState', ['onboardingPageSubmit']),
    ...mapActions('balance', ['init']),
    next() {
      this.onboardingPageSubmit();
      Segment.trackUserInteraction('OBbalancestatenextclicked');
      Segment.trackUserInteraction('OBbalancestatenextclicked_Marketing');
    },
  },
};
</script>

<style lang="scss">
  @import '../../../../../../node_modules/base-ui/src/scss/riseup-colors';

  .osh-balance-information {
    height: 100%;

    .information {

      .body {
        background-color: $riseup_beige;
      }

      img {
        background-color: $riseup_beige;
      }

      lottie-player {
        background-color: $riseup_beige;
      }
    }
  }

</style>
